// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  padding: 48px 0 84px;
  background-color: ${({ theme }) => theme.color.grey4};
  font-weight: ${({ theme }) => theme.fontWeight.medium};

  svg {
    width: 84px;
    height: 84px;
  }

  p {
    align-items: center;
  }

  .slick-slider {
    overflow: hidden;
    margin-bottom: 58px;

    img {
      display: block;
      padding-right: 12px;
    }
  }

  @media only screen and (min-width: 768px) {
    svg {
      width: 130px;
      height: 130px;
    }

    .slick-slider {
      img {
        padding-right: 24px;
      }
    }
  }
`;

export const OptionWarraper = styled.ul`
  margin: 40px;
  display: flex;
  flex-direction: column;

  li {
    margin: 0 0 14px;
    font-size: ${({ theme }) => theme.fontSize.medium};
    text-align: center;

    a {
      color: ${({ theme }) => theme.color.black};
    }
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;

    li {
      margin: 0 16px;
      font-size: ${({ theme }) => theme.fontSize.large};
    }
  }
`;

export const CoppyRigthWarraper = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin-bottom: 8px;
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.medium};
  }

  @media only screen and (min-width: 768px) {
    flex-direction: row;

    p {
      margin-right: 8px;
    }
  }
`;
